'use client';

import { c as _c } from "react/compiler-runtime";
import { ConsumerSubscriptionPlan, useConsumerSubscriptionPlan } from '@udemy-v2/subscription-graphql';
export interface NonCatalogPPPricing {
  nonCatalogPersonalPlan: ConsumerSubscriptionPlan | undefined;
  isAvailable: boolean;
  isLoading: boolean;
  isError: boolean;
  error?: Error;
}
interface UseNonCatalogPPPricingOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch Personal Plan pricing without course catalog filtering.
 *
 * This hook queries for consumer subscription plans independently of the current course,
 * enabling us to show PP pricing for courses that are NOT in the PP catalog but ARE
 * eligible for the non-catalog offer.
 */
export function useNonCatalogPPPricing(t0) {
  const $ = _c(4);
  const {
    enabled: t1
  } = t0 === undefined ? {} : t0;
  const enabled = t1 === undefined ? true : t1;
  const consumerPlanContext = useConsumerSubscriptionPlan();
  const isLoading = enabled && consumerPlanContext && "isLoading" in consumerPlanContext ? consumerPlanContext.isLoading : false;
  const nonCatalogPersonalPlan = enabled && consumerPlanContext && "id" in consumerPlanContext ? consumerPlanContext as ConsumerSubscriptionPlan : undefined;
  const t2 = !!nonCatalogPersonalPlan;
  let t3;
  if ($[0] !== isLoading || $[1] !== nonCatalogPersonalPlan || $[2] !== t2) {
    t3 = {
      nonCatalogPersonalPlan,
      isAvailable: t2,
      isLoading,
      isError: false,
      error: undefined
    };
    $[0] = isLoading;
    $[1] = nonCatalogPersonalPlan;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}